import React from "react";
import PropTypes from "prop-types";
import Icon from "./icon";
import { classStringBuilder, conditionallyAddStyles } from "../support/helpers";

const propTypes = {
  icon: PropTypes.string,
  outline: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  icon: null,
  outline: false,
  className: "",
};

const Button = ({ icon, outline, label, onClick, className }) => {
  const defaultClasses = [
    "w-full",
    "p-4",
    "flex",
    "justify-center",
    "items-center",
    "border-2",
    "border-black",
    "button-text",
  ];

  const additionalClasses = className.split(" ");

  conditionallyAddStyles(
    outline,
    additionalClasses,
    "bg-white",
    "bg-black text-white"
  );

  const classes = classStringBuilder(defaultClasses, additionalClasses);

  return (
    <button className={classes} onClick={onClick}>
      {icon && <Icon iconName={icon} className="mr-4" />}
      {label}
    </button>
  );
};

Button.propTypes = propTypes;

Button.defaultProps = defaultProps;

export default Button;
